import angular from "angular";

angular
    .module('app')
    .component('taskAnswersControl', {
        template: require('./task-answers-control.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            'courses': '<'
        }
    });



function controller($uibModal, Notifier, $http) {
    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.course = null;
    $ctrl.lesson = null;
    $ctrl.user = null;
    $ctrl.status = null;
    $ctrl.perPage = '15';
    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        $ctrl.getAnswers();
    };

    $ctrl.getAnswers = function () {
        $http
            .get('/admin/answers/get-list', {
                params: {
                    page: $ctrl.page,
                    user_id: $ctrl.user ? $ctrl.user.id : null,
                    course_id: $ctrl.course ? $ctrl.course.id : null,
                    lesson_id: $ctrl.lesson ? $ctrl.lesson.id : null,
                    status: $ctrl.status ? $ctrl.status : null,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    per_page: $ctrl.perPage,
                }
            })
            .then(
                function (response) {
                    $ctrl.answers = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {

                }
            );
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.course = null;
        $ctrl.lesson = null;
        $ctrl.user = null;
        $ctrl.status = null;
        $ctrl.getAnswers();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getAnswers();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getAnswers();
    };

    $ctrl.categoryChanged = function () {
        $ctrl.lesson = null;
    };

    $ctrl.getUsers = function (fragment) {
        return $http
            .get('/admin/users/get-by-fragment', {params: {fragment}})
            .then(
                function (response) {
                    return response.data.users;
                }
            )
    };


    $ctrl.openAnswerForm = function (answer) {

        $uibModal
            .open({
                component: 'taskAnswerForm',
                resolve: {
                    answer: function () {
                        return answer;
                    }
                },
                backdrop: 'static',
                size: 'lg'
            })
            .result
            .then(
                function (response) {
                    answer.methodist_answer = response.methodist_answer;
                    answer.status = response.status;
                    answer.result = response.result;
                },
                function (error) {

                }
            );
    };

}
